const toDigits = (postalCode: unknown) =>
  typeof postalCode === 'string' ? postalCode.replace(/\D/g, '') : '';

export default function isGuardianPostalCodeCopied(
  guardianPostalCode: unknown,
  customerPostalCode: unknown,
) {
  return toDigits(guardianPostalCode) === toDigits(customerPostalCode);
}
